import React from 'react';

const QuoteBand = () => {
  return (
    <div className="quote-band">
      <p>"The founders who get premium valuations didn't get lucky. They prepared. Start now — or start explaining later."</p>
    </div>
  );
};

export default QuoteBand;
